<script lang="tsx">
import { defineComponent, type PropType, computed } from 'vue'
import ARKRadio from '../../checkboxes/ARKRadio.vue'
import { RadioSelectFilter } from '../Filters'

export default defineComponent({
  props: {
    filter: {
      type: Object as PropType<RadioSelectFilter>,
      required: true,
    },
  },
  setup(props) {
    const isColumnView = computed(() => props.filter.options.length > 2)

    return () => (

      <div class="ark-ui-filterbar-radio-select-filter">
        <div class="ark-ui-filterbar-radio-select-filter-label">{props.filter.label}</div>

        <div class={`ark-ui-filterbar-radio-select-filter-body ${isColumnView.value ? 'column' : ''}`}>
          {props.filter.options.map((option) => (

            <div
              class="ark-ui-filterbar-radio-select-filter-option"
              onClick={() => (props.filter.addValue(option))}
            >
              <ARKRadio
                modelValue={props.filter.value?.id === option.id}
                onValueChange={() => (props.filter.addValue(option))}
              />

              {option.name}
            </div>

          ))}
        </div>
      </div>

    )
  },
})
</script>

<style lang="scss" scoped>
@import '../../../styles/variables.scss';
.ark-ui-filterbar-radio-select-filter {
  &-label {
    font-size: 14px;
    color: $placeholder-grey;
    margin-bottom: 16px;
  }

  &-body {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 24px;

    &.column {
      flex-direction: column;
    }
  }

  &-option {
    display: flex;
    gap: 8px;
    font-size: 16px;
    cursor: pointer;
  }
}
</style>
